import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Logo from "Pages/Components/Logo";
import { IoClose } from "react-icons/io5";
import * as S from "Pages/Components/Footer/Footer.styles";

function SeparatingLine(): JSX.Element {
  return (
    <div
      style={{
        height: "1px",
        backgroundColor: "rgb(107 107 107)",
        margin: "10px 0",
        width: "100%",
      }}
    />
  );
}

function CheckMark(): JSX.Element {
  return (
    <span
      style={{
        right: 0,
        top: "50%",
        margin: 0,
        position: "absolute",
        transform: "translateY(-50%)",
      }}
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9476 0C6.69152 0 0 6.70501 0 14.9582C0 23.2107 6.69152 29.9164 14.9476 29.9164C23.2037 29.9164 29.9165 23.2107 29.9165 14.9582C29.9165 6.70501 23.2037 0 14.9476 0ZM21.2156 6.75635C21.4174 6.73595 21.6264 6.81314 21.768 6.9583L24.2859 9.57191C24.5281 9.82246 24.5281 10.2668 24.2859 10.5173L14.9157 20.2912L14.4695 20.7586L12.3554 22.9578C12.1026 23.2189 11.6308 23.2189 11.378 22.9578L8.8602 20.3337L5.61996 16.9552C5.37772 16.7049 5.37772 16.2603 5.61996 16.0097L8.18028 13.3434C8.43305 13.0823 8.90489 13.0823 9.15766 13.3434L11.9092 16.2117L20.7907 6.9583C20.9026 6.84373 21.0561 6.76994 21.2156 6.75635Z"
          fill="#FFFFFF"
        />
      </svg>
    </span>
  );
}

export default function BenefitsPopup({
  open,
  onClose,
  showLock,
  showClose,
  version,
}) {
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="get-premium-title"
      open={open}
      fullScreen
    >
      <DialogTitle id="get-premium-title" sx={{ padding: "10px 0px" }}>
        <Logo height={"53px"} />
        <h1
          style={{
            fontFamily: "futura-pt",
            fontWeight: 500,
            fontSize: "2.5em",
            color: "#fff",
            marginTop: "5px",
          }}
        >
          Laid-Back Jazz
        </h1>
        <p
          style={{
            fontFamily: "futura-pt",
            fontWeight: 400,
            fontSize: "1em",
            color: "#b0b0b0",
          }}
        >
          Streaming Ad-Free. Non-Profit.
        </p>
        {showClose && (
          <IconButton
            aria-label="close"
            color="default"
            onClick={() => onClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <IoClose />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        <Typography component="div" textAlign="left">
          <ul style={{ listStyle: "none outside none", padding: 0 }}>
            <li
              style={{
                position: "relative",
                margin: "15px 0",
              }}
            >
              <span style={{ display: "block", maxWidth: "80%" }}>
                <b>Unlimited Access</b> to a meticulously-curated, rare
                collection of 15,000+ songs
              </span>
              <CheckMark />
            </li>
            <SeparatingLine />
            <li
              style={{
                position: "relative",
                margin: "15px 0",
              }}
            >
              <span style={{ display: "block", maxWidth: "80%" }}>
                <b>Audiophile Fidelity</b> (Hi-Res Lossless FLAC)
              </span>
              <CheckMark />
            </li>
            <SeparatingLine />
            <li
              style={{
                position: "relative",
                margin: "15px 0",
              }}
            >
              <span style={{ display: "block", maxWidth: "80%" }}>
                <b>Skip Songs</b>
              </span>
              <CheckMark />
            </li>
            <SeparatingLine />
            <li
              style={{
                position: "relative",
                margin: "15px 0",
              }}
            >
              <span style={{ display: "block", maxWidth: "80%" }}>
                <b>Pure Music</b> (no talk)
              </span>
              <CheckMark />
            </li>
            <SeparatingLine />
            <li
              style={{
                position: "relative",
                margin: "15px 0",
              }}
            >
              <span style={{ display: "block", maxWidth: "80%" }}>
                <b>Devices</b> From iPhone to Sonos & Dozens More, We’ve Got You
                Covered.
              </span>
              <CheckMark />
            </li>
            <SeparatingLine />
          </ul>
        </Typography>
        <Typography
          component="div"
          textAlign="center"
          sx={{ fontSize: "0.9rem", color: "#b0b0b0" }}
        >
          Unlock the benefits above.
        </Typography>
        <Button
          autoFocus
          onClick={showLock}
          style={{
            width: "100%",
            height: "80px",
            margin: "10px 0",
            display: "block",
          }}
        >
          <h1
            style={{
              fontFamily: "futura-pt",
              fontWeight: 500,
              fontSize: "1.9em",
              color: "#fff",
              marginBottom: 0,
            }}
          >
            {(version === "a" && <>Listen Now</>) || <>Get Unlimited Access</>}
          </h1>
          <p
            style={{
              fontFamily: "futura-pt",
              fontWeight: 400,
              fontSize: "1.2em",
              color: "#fff",
            }}
          >
            Sign Up
          </p>
        </Button>
        <Typography
          component="div"
          textAlign="center"
          sx={{ fontSize: "0.9rem", color: "#fff" }}
        >
          No credit card required!
        </Typography>
        <Typography
          component="div"
          textAlign="center"
          sx={{ fontSize: "0.9rem", color: "#fff" }}
        >
          Free one-month membership
        </Typography>
      </DialogContent>
      <Container
        component={Stack}
        direction="row"
        sx={(theme) => ({
          ...theme.typography.body2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "10px",
          [theme.breakpoints.down("sm")]: {
            flexDirection: "column-reverse",
            justifyContent: "center",
          },
        })}
      >
        <Box sx={{ whiteSpace: "nowrap" }}>
          © {new Date().getFullYear()} Foundation to Advance Jazz
        </Box>
        <Box sx={{ whiteSpace: "nowrap" }}>
          <S.HighlightedFooterItem
            component={Link}
            href="https://www.websitepolicies.com/policies/view/VuSlcfN6"
            target="_blank"
          >
            Terms of Use
          </S.HighlightedFooterItem>

          <S.HighlightedFooterItem
            component={(props) => <Link component={RouterLink} {...props} />}
            to="/privacy-policy"
            target="_blank"
          >
            Privacy Policy
          </S.HighlightedFooterItem>
        </Box>
      </Container>
    </Dialog>
  );
}
